import { getAvailableLanguage } from './index.js';
export const availableLocales = (userLocales, appLocales, options = {}) => {
    const matchesToRename = [];
    const matchedLocales = userLocales.filter((userLocale, index) => {
        const formattedUserLocale = options.regionLowerCase
            ? userLocale.toLowerCase()
            : userLocale;
        if (appLocales.includes(formattedUserLocale)) {
            matchesToRename.push({ index, appLocale: formattedUserLocale });
            return true;
        }
        const { isAvailable, appLocale } = getAvailableLanguage(formattedUserLocale, appLocales, options);
        if (isAvailable)
            matchesToRename.push({
                index,
                appLocale: options.regionLowerCase ? appLocale.toLowerCase() : appLocale
            });
        return isAvailable;
    });
    return matchedLocales.map((matchedLocale, index) => {
        if (!matchesToRename || matchesToRename.length === 0)
            return matchedLocale;
        return matchesToRename[index]?.appLocale;
    });
};
